var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "right-board" },
    [
      _c(
        "el-tabs",
        {
          staticClass: "center-tabs",
          model: {
            value: _vm.currentTab,
            callback: function ($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab",
          },
        },
        [
          _c("div", [
            _c("h3", { staticStyle: { margin: "20px" } }, [
              _vm._v(
                _vm._s(_vm.showField && _vm.activeData ? "组件" : "题目组") +
                  "属性"
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "field-box" },
            [
              _c(
                "el-scrollbar",
                { staticClass: "right-scrollbar" },
                [
                  _vm.showField && _vm.activeData
                    ? _c("form-item-config", {
                        attrs: {
                          "active-data": _vm.activeData,
                          "form-conf": _vm.formConf,
                          fields: _vm.fields,
                        },
                        on: {
                          "add-fields": _vm.handleAddFields,
                          "data-change": _vm.dataChange,
                          "other-required-change": _vm.otherRequiredChange,
                        },
                      })
                    : _vm.showField && _vm.activeGroupId !== 0
                    ? _c("form-group-config", {
                        attrs: {
                          activeGroupId: _vm.activeGroupId,
                          fields: _vm.fields,
                          formKey: _vm.formKey,
                        },
                        on: { getProjectList: _vm.getProjectList },
                      })
                    : _c("el-empty", {
                        attrs: { description: "暂无选中组件" },
                      }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }